import { CardWithStatus } from './types'

export const isRequested = (card: CardWithStatus): boolean => {
  if (card.approval) {
    return card.approval.status === 'running'
  } else {
    return card.status === 'requested'
  }
}
